import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { Reveal } from "@/components/site/Motion";

export default function FAQ() {
  return (
    <section className="py-24 sm:py-32 bg-brand-cream">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal className="mb-12 text-center">
          <span className="overline">Questions, answered</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink mt-4">
            Insurance, <span className="italic text-brand-clay">in plain English.</span>
          </h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-brand-line">
                <AccordionTrigger data-testid={`faq-${i}`}
                  className="font-serif text-xl sm:text-2xl text-brand-ink text-left hover:no-underline hover:text-brand-clay py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-brand-moss text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
